export type { ComponentRegistry } from './componentRegistry';
export { createComponentRegistry } from './componentRegistry';
